import { styled } from '@mui/system'
import { Box, Button } from '@mui/material'
import SearchField from 'components/search-field'
import { DataGrid } from '@mui/x-data-grid'
import { switchClient } from 'api/user'
import { removeAccessibleAccount } from 'api/tenant'
import colors from 'common/colors'

export default function UserAccount({ farms = [], onUse }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [searchValue, setSearchValue] = useState('')

  const _onUse = useCallback((tenantId) => {
    dispatch(switchClient(tenantId))
    onUse()
  }, [])

  const onLeave = useCallback((tenantId, userId) => {
    dispatch(removeAccessibleAccount(tenantId, userId))
  }, [])

  const onSearch = useCallback(
    (value) => {
      setSearchValue(value)
    },
    [searchValue],
  )

  const filterFarms = (searchValue, farm) => {
    if (searchValue) {
      return farm.name?.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
    }

    return true
  }

  const columns = [
    {
      field: 'farmName',
      headerName: t('farm'),
      minWidth: 400,
      flex: 1,
    },
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      minWidth: 300,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {/* <Button
              variant="contained"
              color="primary"
              onClick={() => onLeave(params.row.tenantId, params.row.userId)}
            >
              {t('leave')}
            </Button> */}
            <Button
              variant="contained"
              color="primary"
              onClick={() => _onUse(params.row.tenantId, params.row.userId)}
            >
              {t('visit')}
            </Button>
          </>
        )
      },
    },
  ]

  return (
    <Box
      sx={{
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <h1>{t('accessible_accounts')}</h1>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <SearchField
            sx={{ width: '300px' }}
            name={searchValue}
            placeholder={t('search')}
            onSearch={onSearch}
          />
        </Box>
      </Box>
      <div
        style={{
          flexGrow: 1,
          height: '100%',
          width: '100%',
          maxHeight: '800px',
          marginTop: '2rem',
        }}
      >
        <DataGrid
          autoHeight
          rows={farms
            .map((f) => ({ ...f, id: f.tenantId }))
            .filter((f) => filterFarms(searchValue, f))}
          columns={columns}
          sx={{
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: colors.greyBackground,
              textTransform: 'uppercase',
            },
          }}
          initialState={{
            pagination: { paginationModel: { page: 0, pageSize: 20 } },
          }}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </Box>
  )
}
